import { memo } from "react";
import { useTranslation } from "react-i18next";
import { IconPlayerPlayFilled, IconPlayerPauseFilled } from "@tabler/icons-react";

import { Tooltip } from "@fragments";

/**
 * AutoplaySwitch — miniature recessed-well switch (the house toggle metaphor)
 * controlling "reprodução automática", YouTube-style.
 */
function AutoplaySwitch({ enabled, onChange, disabled = false }) {
    const { t } = useTranslation("content");

    return (
        <Tooltip
            content={enabled ? t("player.autoplay.enabled") : t("player.autoplay.disabled")}
            placement="top"
        >
            <button
                type="button"
                role="switch"
                aria-checked={enabled}
                aria-label={t("player.autoplay.label")}
                disabled={disabled}
                className={`player-control-button player-autoplay ${enabled ? "on" : ""}`}
                onClick={(event) => {
                    event.stopPropagation();
                    onChange(!enabled);
                }}
            >
                <span className="player-autoplay__label">{t("player.autoplay.chip")}</span>
                <span className="player-autoplay__track">
                    <span className="player-autoplay__thumb">
                        {enabled ? <IconPlayerPlayFilled /> : <IconPlayerPauseFilled />}
                    </span>
                </span>
            </button>
        </Tooltip>
    );
}

export default memo(AutoplaySwitch);
